//公共的footer 组件

import React from "react";

import { DownOutlined, GlobalOutlined, UpOutlined } from "@ant-design/icons";
import Logo from "@src/images/Logo.svg";
import { Col, Collapse, Dropdown, Menu, Row } from "antd";

import { Link } from "gatsby";

import * as styles from "./index.module.scss";
import { useI18n } from "@src/i18n";

const footerData = [
  {
    parentInfoKey: "footer.product",
    sonNodes: [
      {
        targetNameKey: "header.home",
        targetUrl: "/",
      },
      {
        targetNameKey: "header.shoprise",
        targetUrl: "/shoprise",
      },
      {
        targetNameKey: "header.pricing",
        targetUrl: "/pricing",
      },
      {
        targetNameKey: "header.productFeatures",
        targetUrl: "/product-features",
      },
      {
        targetNameKey: "header.theme",
        targetUrl: "/theme",
      }, {
        targetNameKey: "header.advertising",
        targetUrl: "/advertising",
      },
    ],
  },
  {
    parentInfoKey: "footer.service",
    sonNodes: [
      // {
      //   targetName: "帮助中心",
      //   targetUrl: "/helpcenter",
      // },
      {
        targetNameKey: "header.question",
        targetUrl: "/question",
      },
      // {
      //   targetName: "投诉建议",
      //   targetUrl: "/complaints",
      // },
    ],
  },
  {
    parentInfoKey: "footer.company",
    sonNodes: [
      {
        targetNameKey: "header.aboutus",
        targetUrl: "/aboutus",
      },
      {
        targetNameKey: "header.partner",
        targetUrl: "/partner",
      },
      {
        targetNameKey: "footer.agreement",
        targetUrl: "/agreement",
      },
      {
        targetNameKey: "footer.terms",
        targetUrl: "/terms",
      },
      {
        targetNameKey: "footer.privacy",
        targetUrl: "/privacy",
      },
    ],
  },
];

const { Panel } = Collapse;

const LanguageSwitch = () => {
  const { locale, setLocale, t } = useI18n();
  const languageMenu = (
    <Menu
      className={styles.languageMenu}
      selectedKeys={[locale]}
      onClick={({ key }) => setLocale(key)}
    >
      <Menu.Item key="zh-CN">{t("footer.chinese")}</Menu.Item>
      <Menu.Item key="en-US">{t("footer.english")}</Menu.Item>
    </Menu>
  );

  return (
    <Dropdown
      overlay={languageMenu}
      placement="topCenter"
      trigger={["click"]}
      overlayClassName={styles.languageDropdown}
    >
      <button
        type="button"
        className={styles.languageSwitch}
        aria-label={t("footer.languageSelector")}
      >
        <GlobalOutlined />
        <span>
          {locale === "zh-CN" ? t("footer.chinese") : t("footer.english")}
        </span>
        <DownOutlined className={styles.languageArrow} />
      </button>
    </Dropdown>
  );
};

const IndexFooter = () => {
  const { t } = useI18n();

  return (
    <div className={styles.footer}>
      <Row>
        <Col xs={0} sm={0} md={24}>
          <div className={styles.pcContainer}>
            <div className={styles.footerMain}>
              {footerData.map((item) => {
                return (
                  <div key={item.parentInfoKey}>
                    <p
                      style={{
                        color: "#111",
                        fontSize: "18px",
                        fontWeight: "bold",
                      }}
                    >
                      {t(item.parentInfoKey)}
                    </p>
                    {item.sonNodes.map((item) => {
                      return (
                        <div
                          key={item.targetNameKey}
                          style={{ lineHeight: "37px" }}
                        >
                          <Link
                            to={item.targetUrl}
                            style={{ color: "#686666" }}
                          >
                            {t(item.targetNameKey)}
                          </Link>
                        </div>
                      );
                    })}
                  </div>
                );
              })}
            </div>
            <div style={{ borderBottom: "1px solid #A6A6A6" }} />
            <div className={styles.footerIntro}>
              <div className={styles.footerMeta}>
                <img src={Logo} alt="logo" />
                <div className={styles.policyLinks}>
                  <Link to="/agreement" style={{ color: "#686666" }}>
                    {t("footer.agreement")}
                  </Link>
                  <span style={{ margin: "0 10px" }}>|</span>
                  <Link to="/terms" style={{ color: "#686666" }}>
                    {t("footer.terms")}
                  </Link>
                  <span style={{ margin: "0 10px" }}>|</span>
                  <Link to="/privacy" style={{ color: "#686666" }}>
                    {t("footer.privacy")}
                  </Link>
                </div>
                <div className={styles.contactInfo}>
                  {/* <span>©2021成都泛兮科技有限公司 </span> */}
                  <div className={styles.contactDetails}>
                    <span>support@shoprise.com</span>
                    <br />
                    {/* <span>{t("footer.location")}</span> */}
                  </div>
                </div>
              </div>
              <LanguageSwitch />
            </div>
          </div>
        </Col>
        <Col
          xs={24}
          sm={24}
          md={0}
          style={{ paddingTop: "34px", background: "#F9FBFE" }}
        >
          <Collapse
            // defaultActiveKey={["1"]}
            expandIconPosition="right"
            bordered={false}
            expandIcon={({ isActive }) => (
              <UpOutlined rotate={isActive ? 0 : 180} />
            )}
          >
            {footerData.map((item) => {
              return (
                <Panel
                  header={
                    <span
                      style={{
                        fontWeight: "400",
                        color: "#111",
                        fontSize: "16px",
                      }}
                    >
                      {t(item.parentInfoKey)}
                    </span>
                  }
                  key={item.parentInfoKey}
                  style={{
                    border: "none",
                    backgroundColor: "#F9FBFE",
                  }}
                >
                  {item.sonNodes.map((item) => {
                    return (
                      <Link
                        to={item.targetUrl}
                        style={{ color: "#000" }}
                        key={item.targetNameKey}
                      >
                        <div style={{ padding: "0 8px", lineHeight: "34px" }}>
                          {t(item.targetNameKey)}
                        </div>
                      </Link>
                    );
                  })}
                </Panel>
              );
            })}

            <div
              style={{
                margin: "0 5%",
                borderBottom: "1px solid  #686666",
                width: "90%",
                height: "1px",
                paddingTop: "15px",
                backgroundColor: "#F9FBFE",
              }}
            ></div>
          </Collapse>
          <div className={styles.mobileFooterInfo}>
            {/* <p>©2021成都泛兮科技有限公司</p> */}
            <p>support@shoprise.com</p>
            {/* <p>{t("footer.location")}</p> */}
            <LanguageSwitch />
            <div className={styles.mobilePolicyLinks}>
              <Link to="/agreement" style={{ color: "#000" }}>
                {t("footer.agreement")}
              </Link>
              <Link to="/terms" style={{ color: "#000" }}>
                {t("footer.terms")}
              </Link>
              <Link to="/privacy" style={{ color: "#000" }}>
                {t("footer.privacy")}
              </Link>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default IndexFooter;
